import $ from 'jquery';

/**
 * @function cloneObject
 * @description Clone an object
 *
 * @param {object} datas - Object to be cloned
 *
 * @return {object} - Cloned object
 */

export const cloneObject = (datas: any): any => {

  const output: {[key: string]: any} = {};
  $.each(datas, (key: string, data: any) => {
    output[key] = data;
  });

  return output;

};
